<div class="exchange-rate-info-cont">
  <p class="cont-text">
    {{'BOOKING_MODULE.EXCHANGE_RATE_MESSAGE' | transloco : {
        money: currencyExchangeName,
        exchange: oneMoney | currencyFormat : currencyCode,
        rate: oneMoney | exchangeCurrency : conversionRate : true
      }
    }}
  </p>
</div>